export function redirectToLoginIfUnauthorized(err, router, route) {
  if (err.response?.status !== 401) return false

  router.replace({ name: 'login', query: { redirect: route.fullPath } })
  return true
}
